import { render, staticRenderFns } from "./SeoForm.vue?vue&type=template&id=70c6dd95&"
import script from "./SeoForm.vue?vue&type=script&lang=js&"
export * from "./SeoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports